import { FC } from 'react'
import styled from 'styled-components'
import FilterFieldWrapper from '@app.feature/activityFilter/components/FilterFieldWrapper'
import useFilterItem from '@app.feature/activityFilter/hooks/useFilterItem'
import { TActivityFilterItem } from '@app.feature/activityFilter/store/storeActivityFilter'
import FilterItem from './FilterItem'
import SlideWrapper from './SlideWrapper'

interface IFSlideFilterFieldProps {
  label: string
  name: string
  items: TActivityFilterItem[]
  onChange: (item: TActivityFilterItem) => void
  className?: string
}

const SlideFilterField: FC<IFSlideFilterFieldProps> = ({
  label,
  name,
  items,
  onChange,
  className,
}) => {
  const { filterItemIsSelected } = useFilterItem()

  const handleClick = (item) => {
    onChange(item)
  }

  return (
    <StyledWrapper label={label} className={className}>
      <SlideWrapper>
        {items.map((itemData) => {
          const isSelected = filterItemIsSelected({
            name,
            filterItemId: itemData.id,
          })
          return (
            <FilterItem
              key={itemData.id}
              item={itemData}
              isActive={isSelected}
              onClick={handleClick}
            />
          )
        })}
      </SlideWrapper>
    </StyledWrapper>
  )
}

export default SlideFilterField

const StyledWrapper = styled(FilterFieldWrapper)``
